import { ScheduleInfo } from "../../../../redux/curriculum/model";

export interface CalendarEvent extends ScheduleInfo {
  /** Início do agendamento (Ex: timestamp ou minutos desde o início do dia) */
  start: number;
  /** Fim do agendamento (Ex: timestamp ou minutos desde o início do dia) */
  end: number;
  // Você pode ter outras propriedades aqui...
}

export interface PositionedEvent extends CalendarEvent {
  /** Posição horizontal onde o card deve começar (em porcentagem: 0 a 100) */
  left: number;
  /** Largura que o card deve ocupar (em porcentagem: 0 a 100) */
  width: number;
  /** O índice da sub-coluna interna deste evento (útil caso precise aplicar cores ou z-index) */
  columnIndex: number;
}

export function layoutCalendarEvents(events: CalendarEvent[]): PositionedEvent[] {
  if (!events || events.length === 0) return [];

  // 1. Ordenar por horário de início (se igual, o que termina mais cedo vai primeiro)
  const sortedEvents = [...events].sort((a, b) => a.start - b.start || a.end - b.end);

  const groups: CalendarEvent[][] = [];
  let currentGroup: CalendarEvent[] = [];
  let currentGroupEnd = 0;

  // 2. Fase de Agrupamento (Clustering)
  for (const event of sortedEvents) {
    if (event.start >= currentGroupEnd) {
      // Sem colisão: fecha o grupo atual e inicia um novo
      if (currentGroup.length > 0) {
        groups.push(currentGroup);
      }
      currentGroup = [event];
      currentGroupEnd = event.end;
    } else {
      // Com colisão: adiciona ao grupo e expande o limite final se necessário
      currentGroup.push(event);
      if (event.end > currentGroupEnd) {
        currentGroupEnd = event.end;
      }
    }
  }
  
  if (currentGroup.length > 0) {
    groups.push(currentGroup);
  }

  const positionedEvents: PositionedEvent[] = [];

  // 3. Fase de Distribuição (Packing) dentro de cada grupo
  for (const group of groups) {
    // Array de sub-colunas. Cada sub-coluna guarda uma lista de eventos que não batem horário.
    const columns: CalendarEvent[][] = [];

    for (const event of group) {
      let placed = false;
      let columnIndex = 0;

      // Percorre as colunas existentes para ver se este evento cabe em alguma
      for (let i = 0; i < columns.length; i++) {
        const lastEventInColumn = columns[i][columns[i].length - 1];
        
        // Se o evento começa exatamente quando ou depois que o último da coluna termina
        if (event.start >= lastEventInColumn.end) {
          columns[i].push(event);
          columnIndex = i;
          placed = true;
          break;
        }
      }

      // Se colidiu com todas as colunas existentes, abre uma nova sub-coluna
      if (!placed) {
        columns.push([event]);
        columnIndex = columns.length - 1;
      }

      // Criamos o objeto já com a tipagem estendida
      const totalColumns = columns.length; // Temporário, será recalculado no passo final do grupo
      
      // Armazenamos o columnIndex temporariamente no objeto para a próxima etapa
      (event as any)._tempColumnIndex = columnIndex;
    }

    // Como o número total de colunas do grupo pode ter aumentado ao longo do loop,
    // recalculamos o left e width corretos de todos os membros do grupo agora.
    const totalColumns = columns.length;
    
    for (const event of group) {
      const columnIndex = (event as any)._tempColumnIndex;
      delete (event as any)._tempColumnIndex; // Limpa a propriedade temporária

      positionedEvents.push({
        ...event,
        columnIndex,
        left: (columnIndex / totalColumns) * 100,
        width: (1 / totalColumns) * 100,
      });
    }
  }

  return positionedEvents;
}